import React, { useEffect } from "react";
import { Form } from "semantic-ui-react";

// Hooks and Helpers
import useSuspiciousActivityForm from "@common/components/hooks/useSuspiciousActivityForm";
import {
  getCurrentDateTime,
  setComplianceFormDateTime,
} from "../../helpers/datetime";

// Components
import TextareaComponent from "@common/components/shared/forms/TextareaComponent";
import SelectComponent from "@common/components/shared/forms/SelectComponent";
import StandardHiddenInputs from "@common/components/shared/forms/StandardHiddenInputs";
import ToggleComponent from "@common/components/shared/forms/ToggleComponent";
import FormButtonsComponent from "@common/components/shared/forms/FormButtonsComponent";
import DateAndTimeGroup from "@common/components/shared/forms/DateAndTimeGroup";
import SuspectsForm from "./SuspectsForm";
import EmergencyServicesForm from "@common/components/shared/forms/EmergencyServicesForm";
import InputComponent from "@common/components/shared/forms/InputComponent";
import UploadComponent from "@common/components/shared/forms/UploadComponent";
import useLinkedSession from "../../hooks/useLinkedSession";
import AlertsAndSessions from "../AlertsAndSessions";

const SuspiciousActivityForm = () => {
  const {
    policeInvolved,
    servicesDidNotAttend,
    onSubmit,
    resetForm,
    onError,
    methods,
    types,
    isDesktop,
    optionDisplaySessionsInCompliance,
  } = useSuspiciousActivityForm();

  const { setState } = useLinkedSession();

  const {
    control,
    register,
    setValue,
    handleSubmit,
    watch,
    formState: { isValid, errors },
  } = methods;
  const watchCctv = watch("cctvCatched");

  useEffect(() => {
    if (!isDesktop) {
      setComplianceFormDateTime(setValue);
    }
    setState({ name: "machine" });
  }, []);

  return (
    <Form className="form-padding" onSubmit={handleSubmit(onSubmit, onError)}>
      <StandardHiddenInputs />
      <DateAndTimeGroup
        control={control}
        dateFormat="YYYY-MM-DD"
        errorsDate={errors.date}
        errorsTime={errors.time}
        maxDate={getCurrentDateTime()}
      />
      <SelectComponent
        name="activityType"
        label="Type"
        placeholder="Select type of suspicious activity"
        control={control}
        error={errors.activityType}
        options={types}
      />
      {optionDisplaySessionsInCompliance ? (
        <AlertsAndSessions />
      ) : (
        <InputComponent
          label="Machine"
          name="machineReference"
          placeholder="Please enter the machine details [Asset No & Game Name]"
          register={register}
          error={errors.machineReference}
        />
      )}
      <ToggleComponent
        control={control}
        name="cctvCatched"
        label="Captured by CCTV?"
        error={errors.cctvCatched}
      />
      {isDesktop && watchCctv && <UploadComponent />}
      <TextareaComponent
        name="description"
        label="Description"
        placeholder="Enter details of the suspicious activity and witnesses"
        register={register}
        error={errors.description}
      />
      <br />
      <TextareaComponent
        name="outcome"
        label="Outcome"
        placeholder="Enter details of how the issue was resolved and outcome"
        register={register}
        error={errors.outcome}
      />
      <SuspectsForm />
      <EmergencyServicesForm
        control={control}
        register={register}
        errors={errors}
        setValue={setValue}
        eSCalled={policeInvolved}
        policeCalled={true}
        didNotAttend={servicesDidNotAttend}
        policeOnly={true}
      />
      <TextareaComponent
        name="comments"
        label="Comments"
        placeholder="Please enter comments..."
        register={register}
        fieldStyle="py-1"
      />
      <FormButtonsComponent
        isValid={isValid}
        centered={true}
        resetForm={() => resetForm(false)}
      />
    </Form>
  );
};

export default SuspiciousActivityForm;
